import { createStructuredSelector } from 'reselect'

import {
  ARTICLE_LIST,
  ARTICLE_LIST_SUCCESS,
  ARTICLE_LIST_ERROR,
  ARTICLE_SEARCH_ARTICLE_GROUP_LIST,
  ARTICLE_SEARCH_ARTICLE_GROUP_LIST_SUCCESS,
  ARTICLE_SEARCH_ARTICLE_GROUP_LIST_ERROR,
  ARTICLE_SEARCH_SET,
  ARTICLE_PAGE_SET,
  ARTICLE_VIEW_MODAL_SET,
  ARTICLE_VIEW_TAB_SET,
  ARTICLE_SEARCH_CHANGE,
  ARTICLE_HEADER,
  ARTICLE_SEARCH_PROJECT_LIST,
  ARTICLE_SEARCH_PROJECT_LIST_SUCCESS,
  ARTICLE_SEARCH_PROJECT_LIST_ERROR,
  ARTICLE_SEARCH_YEAR_LIST,
  ARTICLE_SEARCH_YEAR_LIST_SUCCESS,
  ARTICLE_SEARCH_YEAR_LIST_ERROR,
  ARTICLE_SEARCH_ARTICLE_TYPE_LIST,
  ARTICLE_SEARCH_ARTICLE_TYPE_LIST_SUCCESS,
  ARTICLE_SEARCH_ARTICLE_TYPE_LIST_ERROR,
  ARTICLE_DETAIL,
  ARTICLE_DETAIL_SUCCESS,
  ARTICLE_DETAIL_ERROR,
  ARTICLE_SEARCH_DEMAND_LIST,
  ARTICLE_SEARCH_DEMAND_LIST_SUCCESS,
  ARTICLE_SEARCH_DEMAND_LIST_ERROR,
} from '../actions';

export const NAME = 'article';

export const ArticleList = (page, num_page, orderBy, filters, stateFilter) => ({
  type: ARTICLE_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const ArticleListSuccess = (data) => ({
  type: ARTICLE_LIST_SUCCESS,
  payload: data
});

export const ArticleListError = (error) => ({
  type: ARTICLE_LIST_ERROR,
  payload: error
});

export const ArticleSearchArticleGroupList = () => ({
  type: ARTICLE_SEARCH_ARTICLE_GROUP_LIST
});

export const ArticleSearchArticleGroupListSuccess = (data) => ({
  type: ARTICLE_SEARCH_ARTICLE_GROUP_LIST_SUCCESS,
  payload: data
});

export const ArticleSearchArticleGroupListError = (error) => ({
  type: ARTICLE_SEARCH_ARTICLE_GROUP_LIST_ERROR,
  payload: error
});

export const ArticleSearchSet = (data) => ({
  type: ARTICLE_SEARCH_SET,
  payload: data
});

export const ArticlePageSet = (data) => ({
  type: ARTICLE_PAGE_SET,
  payload: data
});

export const ArticleViewModalSet = (data) => ({
  type: ARTICLE_VIEW_MODAL_SET,
  payload: data
});


export const ArticleHeader = (data) => ({
  type: ARTICLE_HEADER,
  payload: data
});

export const ArticleViewTabSet = (data) => ({
  type: ARTICLE_VIEW_TAB_SET,
  payload: data
});


export const ArticleSearchChangeSet = (data) => ({
  type: ARTICLE_SEARCH_CHANGE,
  payload: data
});

export const ArticleSearchProjectList = () => ({
  type: ARTICLE_SEARCH_PROJECT_LIST
});

export const ArticleSearchProjectListSuccess = (message) => ({
  type: ARTICLE_SEARCH_PROJECT_LIST_SUCCESS,
  payload: message
});

export const ArticleSearchProjectListError = (error) => ({
  type: ARTICLE_SEARCH_PROJECT_LIST_ERROR,
  payload: error
}); 

export const ArticleSearchYearList = () => ({
  type: ARTICLE_SEARCH_YEAR_LIST
});

export const ArticleSearchYearListSuccess = (message) => ({
  type: ARTICLE_SEARCH_YEAR_LIST_SUCCESS,
  payload: message
});

export const ArticleSearchYearListError = (error) => ({
  type: ARTICLE_SEARCH_YEAR_LIST_ERROR,
  payload: error
}); 


export const ArticleSearchArticleTypeList = () => ({
  type: ARTICLE_SEARCH_ARTICLE_TYPE_LIST
});

export const ArticleSearchArticleTypeListSuccess = (message) => ({
  type: ARTICLE_SEARCH_ARTICLE_TYPE_LIST_SUCCESS,
  payload: message
});

export const ArticleSearchArticleTypeListError = (error) => ({
  type: ARTICLE_SEARCH_ARTICLE_TYPE_LIST_ERROR,
  payload: error
});

export const ArticleDetail = (data) => ({
  type: ARTICLE_DETAIL,
  payload: data
});

export const ArticleDetailSuccess = (data) => ({
  type: ARTICLE_DETAIL_SUCCESS,
  payload: data
});

export const ArticleDetailError = (error) => ({
  type: ARTICLE_DETAIL_ERROR,
  payload: error
});

export const ArticleSearchDemandList = () => ({
  type: ARTICLE_SEARCH_DEMAND_LIST
});

export const ArticleSearchDemandListSuccess = (message) => ({
  type: ARTICLE_SEARCH_DEMAND_LIST_SUCCESS,
  payload: message
});

export const ArticleSearchDemandListError = (error) => ({
  type: ARTICLE_SEARCH_DEMAND_LIST_ERROR,
  payload: error
}); 
const article = (state) => state[NAME];

export const ArticleSelector = createStructuredSelector({
  article
})
